import OrganizationsProjects from "../controllers/Organization/OrganizationsProjects";
import { parseFilter } from "colbi_web_ui/lib/utils";
import { DataGrid, rows } from "colbi_web_ui/lib/components";
import OrganizationProjectToolbar from "../components/OrganizationProjectToolbar/OrganizationProjectToolbar";

const queries = (args) => {
    const { filter, organizationId } = args;

    const queriesWithOrgId = [
        {
            resource: "organization_projects",
            args: {
                filter: filter ? { type: "[FilterInput!]", value: parseFilter(filter) } : undefined,
                organizationId: organizationId,
            },
            body: "organizationProject{id,name,maxFiscalYear,fiscalYears,calendarYears,mosaicThemeConfig,projects{id,name,fiscalYears,status,taxRegistrationNumber,active,projectExpired,aggregationDataResult,mosaicThemeConfig,modules{navigation_by_import_id,name,default_route,default_module}},organizationExpired,organizationActive}, __typename, metadata, filters{ prop, name, type, list, disableOperators, mandatory}",
            forceRefresh: true,
            isDatagridReq: true,
        },
    ];

    return [...queriesWithOrgId].filter((r) => r);
};

const userProjectsByOrganization = (path, navigation, exact, title) => ({
    path,
    navigation: navigation,
    component: OrganizationsProjects,
    queries,
    exact,
    title: [`label(${title})`],
    components: [
        {
            component: DataGrid,
            props: {
                id: "results",
                card: rows.CellCard,
                footer: "query(0).footer",
                metadata: "query(0).metadata",
                page: "param(page)",
                status: "status(0)",
                sort: "param(sort)",
                pageSize: "param(pageSize)",
                pageDefault: 10,
                filter: "param(filter)",
                availableFilters: "query(0).filters",
                wrapper: "wrapper",
                headerHeight: 50,
                showCheckbox: "query(0).showCheckbox",
                total: "query(0).metadata.total",
                hideDeleteSeriesButton: true,
                enablePagination: false,
                toolbar: OrganizationProjectToolbar,
                modifierssx: {
                    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
                        width: "100%",
                    },
                },
            },
        },
    ],
});

export default userProjectsByOrganization;
